import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { PiArrowLeft, PiDotsThreeBold, PiEye, PiEyeSlash } from 'react-icons/pi';
import { useFinancialPrivacy } from '../../FinancialPrivacyContext';
import './styles.css';

const AccountPageHeader = ({ title, onBack, wide = false }) => {
  const { valuesVisible, toggleValuesVisibility } = useFinancialPrivacy();

  return (
  <header className={`account-page-header ${wide ? 'account-page-header--wide' : ''}`.trim()}>
    <button
      type="button"
      className="account-page-header__back"
      onClick={onBack}
      aria-label="Voltar"
    >
      <PiArrowLeft size={22} aria-hidden="true" />
    </button>

    <div className="account-page-header__content">
      <h1>{title}</h1>
    </div>
    {wide && (
      <div className="account-page-header__actions">
        <button type="button" className="account-page-header__privacy" onClick={toggleValuesVisibility} aria-label={valuesVisible ? 'Ocultar valores' : 'Mostrar valores'}>
          {valuesVisible ? <PiEye aria-hidden="true" /> : <PiEyeSlash aria-hidden="true" />}
        </button>
        <details className="account-page-header__menu">
          <summary aria-label="Abrir ações do Dashboard"><PiDotsThreeBold aria-hidden="true" /></summary>
          <nav className="account-page-header__menu-panel" aria-label="Ações do Dashboard">
            <Link to="/dashboard">Visão geral</Link>
            <Link to="/movimentacoes">Movimentações</Link>
            <Link to="/planejamento">Planejamento</Link>
          </nav>
        </details>
      </div>
    )}
  </header>
  );
};

AccountPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
  wide: PropTypes.bool,
};

export default AccountPageHeader;